import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Button, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AverageRating from './AverageRating';
import RecommendationSummary from './RecommendationSummary';

const classes = {
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
};
export const minimumNumberOfLines = 3;

const SummaryContent = ({ headerTitle, shortSummaryTitle, shortSummaryIcon, data, type }) => {
	const { t } = useTranslation(['candidate-feedback']);
	const {
		viewMore,
		viewLess,
		viewMoreAriaLabel,
		viewLessAriaLabel,
		mixedOpinions,
		recommendationsAriaLabel,
		averageRatingAriaLabel,
	} = useMemo(
		() => ({
			viewMore: t('view_more'),
			viewLess: t('view_less'),
			viewMoreAriaLabel: t('view_more_aria_label', { type: t(headerTitle) }),
			viewLessAriaLabel: t('view_less_aria_label', { type: t(headerTitle) }),
			mixedOpinions: t('mixed_opinions_aria_label'),
			recommendationsAriaLabel: t('recommendation_aria_label', { status: t(shortSummaryTitle) }),
			averageRatingAriaLabel: t('average_rating_aria_label', { averageRating: shortSummaryTitle }),
		}),
		[headerTitle, shortSummaryTitle, t],
	);
	const [isViewMore, setIsViewMore] = useState(false);
	const handleOnClick = () => setIsViewMore(!isViewMore);

	const ariaLabelByType = {
		recommendations:
			shortSummaryTitle === 'mixed_opinions' ? mixedOpinions : recommendationsAriaLabel,
		averageRating: averageRatingAriaLabel,
	};
	return (
		<Box>
			<Box sx={classes.header}>
				<Box sx={classes.header} id={`summary-header-${type}`}>
					<Typography variant="h3">
						{headerTitle} <span className="screenreader">: {ariaLabelByType[type]}</span>
					</Typography>
					{data?.length > minimumNumberOfLines && (
						<Button
							variant="text"
							size="small"
							sx={{ marginX: '8px' }}
							data-testid="view-more-button"
							aria-label={isViewMore ? viewLessAriaLabel : viewMoreAriaLabel}
							aria-controls={`collapsable-content-${type}`}
							aria-expanded={isViewMore}
							endIcon={
								<KeyboardArrowUpIcon
									sx={{ transform: isViewMore ? 'rotate(0deg)' : 'rotate(180deg)' }}
								/>
							}
							onClick={handleOnClick}
						>
							{isViewMore ? viewLess : viewMore}
						</Button>
					)}
				</Box>
				<Box sx={classes.header}>
					<Typography variant="h2" aria-hidden="true">
						{t(shortSummaryTitle)}
					</Typography>
					{shortSummaryIcon}
				</Box>
			</Box>
			<Box aria-labelledby={`summary-header-${type}`} id={`collapsable-content-${type}`}>
				{type === 'recommendations' ? (
					<RecommendationSummary data={data} viewAll={isViewMore} />
				) : (
					<AverageRating data={data} viewAll={isViewMore} />
				)}
			</Box>
		</Box>
	);
};

export default SummaryContent;
